import * as React from 'react';
import { TPromoBanner } from './PromoBanner.types';
import { Button } from 'components';
import { useNavigate } from 'react-router';
import { APP_ROUTES } from '../../../../constants/routes';
import './PromoBanner.styled.scss';

export const PromoBanner: TPromoBanner = () => {
  const navigate = useNavigate();

  const handleGoToCatalog = () => {
    navigate(APP_ROUTES.PRODUCTS);
  };

  return (
    <div className="promo-banner">
      <div className="promo-banner__content">
        <div className="promo-banner__left">
          <h1 className="promo-banner__title">ЧОРНА ПЯТНИЦЯ</h1>
          <Button
            variant="contained"
            className="promo-banner__button"
            onClick={handleGoToCatalog}
          >
            ПЕРЕЙТИ ДО КАТАЛОГУ
          </Button>
          <p className="promo-banner__subtitle">до -30% на чохли для iPhone</p>
        </div>
        <div className="promo-banner__right">
          <div className="promo-banner__phones">
            <div className="promo-banner__phone promo-banner__phone--1"></div>
            <div className="promo-banner__phone promo-banner__phone--2"></div>
            <div className="promo-banner__phone promo-banner__phone--3"></div>
          </div>
          <h2 className="promo-banner__right-title">ЦІЛИХ ДВА ТИЖНІ ЗНИЖОК</h2>
        </div>
      </div>
      <div className="promo-banner__dots">
        <span className="promo-banner__dot promo-banner__dot--active"></span>
        <span className="promo-banner__dot"></span>
        <span className="promo-banner__dot"></span>
      </div>
    </div>
  );
};
